var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "52DDD9D9-DFBB-4E00-97ED-283C0108359D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-278.000000, -374.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tile",
    transform: "translate(278.000000, 374.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-100",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    x: 34,
    y: 34,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-102",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    x: 34,
    y: 0,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-101",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    x: 0,
    y: 34,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-103",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "Title-Copy-5",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 46.3608398,
    y: 46,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Title-Copy-8",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 46.3608398,
    y: 12,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Title-Copy-7",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.3608398,
    y: 46,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Title-Copy-9",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.3608398,
    y: 12,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-dolor-si-Copy-5",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 2.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 38.3616943,
    y: 50,
    fill: "#6F6F6F"
  }, "Lorem ipsum dolor "), /*#__PURE__*/React.createElement("tspan", {
    x: 44.8210449,
    y: 54,
    fill: "#6F6F6F"
  }, "sit amet")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-dolor-si-Copy-7",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 2.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 38.3616943,
    y: 16,
    fill: "#6F6F6F"
  }, "Lorem ipsum dolor "), /*#__PURE__*/React.createElement("tspan", {
    x: 44.8210449,
    y: 20,
    fill: "#6F6F6F"
  }, "sit amet")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-dolor-si-Copy-6",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 2.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.36169434,
    y: 50,
    fill: "#6F6F6F"
  }, "Lorem ipsum dolor "), /*#__PURE__*/React.createElement("tspan", {
    x: 10.8210449,
    y: 54,
    fill: "#6F6F6F"
  }, "sit amet")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-dolor-si-Copy-8",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 2.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.36169434,
    y: 16,
    fill: "#6F6F6F"
  }, "Lorem ipsum dolor "), /*#__PURE__*/React.createElement("tspan", {
    x: 10.8210449,
    y: 20,
    fill: "#6F6F6F"
  }, "sit amet")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTile);
export default __webpack_public_path__ + "static/media/Tile.98b23f87cb39e12a3732c7179e2ee2e8.svg";
export { ForwardRef as ReactComponent };